import { Select } from "antd";
import { SelectProps } from "antd/lib/select";
import React from "react";

interface Option {
  value: string;
  label: string;
}

interface AppSelectFilterProps extends SelectProps {
  label: string;
  options: Option[];
  onChange: (value: string) => void;
  placeHolder?: string;
}

const AppSelectFilter: React.FC<AppSelectFilterProps> = ({
  label,
  options,
  onChange,
  placeHolder = "",
  ...rest
}) => {
  return (
    <div>
      <label className="app-select-filter-label">{label}</label>
      <Select
        // className="app-select-filter-select"
        style={{ width: "100%", height: "44px", marginTop: "5px" }}
        onChange={(value) => onChange(value)}
        {...rest}
        placeholder={placeHolder}
        showSearch
        allowClear
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default AppSelectFilter;
